import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { adminError } from "../../lib/jamoraAdmin";
import { useAdminSession } from "./SessionProvider";

// Entering the application = confirming the CRM password again. It is a confirmation, not a second identity: no Jamora password exists here.
export default function SessionGate() {
  const { open } = useAdminSession();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (!password || busy) return;
    setBusy(true);
    setError("");
    try {
      await open(password);
      setPassword("");
    } catch (e) {
      const status = e?.response?.status;
      setError(status === 401 ? "Mot de passe incorrect." : status === 429 ? "Trop de tentatives. Réessayez dans 15 minutes."
        : adminError(e, "Impossible d'ouvrir l'administration. Réessayez."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex justify-center py-6 sm:py-12" data-testid="admin-gate">
      <Card className="w-full max-w-md p-6 space-y-4">
        <div className="flex items-start gap-3">
          <span className="rounded-lg bg-stone-100 text-stone-700 p-2"><ShieldCheck size={20} aria-hidden="true" /></span>
          <div className="space-y-1">
            <h1 className="font-display font-bold text-xl text-slate-900">Jamora App</h1>
            <p className="text-sm text-slate-600">Cet espace donne accès à toutes les pharmacies. Confirmez votre mot de passe du CRM pour l'ouvrir.</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="admin-password">Mot de passe du CRM</Label>
            <Input id="admin-password" type="password" autoComplete="current-password" autoFocus value={password} className="h-10"
              onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" aria-invalid={!!error} aria-describedby={error ? "admin-gate-error" : undefined} />
          </div>
          {error && <p id="admin-gate-error" className="text-sm text-red-600" role="alert" data-testid="admin-gate-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy || !password} data-testid="admin-gate-submit">
            {busy && <Loader2 size={14} className="mr-1.5 animate-spin" />}Ouvrir l'administration
          </Button>
        </form>
        <p className="text-xs text-slate-500">La session se ferme après 30 minutes sans activité. Tout ce que vous y faites est en lecture seule et journalisé.</p>
      </Card>
    </div>
  );
}
